module.exports = __webpack_public_path__ + "static/media/Union.021554a1.jpg";